import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//shows moving details like moving people,moving trucks,moving hours etc.
    let IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails
    const mp = (IV2_PageDetails && IV2_PageDetails.MoveAndPackDetails) ? IV2_PageDetails.MoveAndPackDetails : {};
    const jobTimes = (IV2_PageDetails && IV2_PageDetails.TimeRecord && Array.isArray(IV2_PageDetails.TimeRecord.JobTimes)) ? IV2_PageDetails.TimeRecord.JobTimes : [];
    const movingCount = jobTimes.filter(item => item.HoursType === 'Moving').length;
    const showRate = !mp.ContitionForRate && movingCount <= 1;
    return (
        <>
            <div className='bg-secondary small'>
                <div className='row'>
                    <LabelAndInput label='MOVERS' value={mp.Movingpeople} inputClass='wide-field'/>
                    <LabelAndInput label='TRUCKS' value={mp.MovingTrucks} inputClass='wide-field'/>
                    {showRate && <LabelAndInput label='RATE' value={mp.HourlyRate} />}
                    <LabelAndInput label='HOURS' value={mp.MovingHours} inputClass='hours-wide'/>
                </div>
                {mp.ConditionForPackDetails ?
                    <div className='row mt-2'>
                        <LabelAndInput label='PACK MOVERS' value={mp.PackingCrewSize}/>
                        <LabelAndInput label='PACK RATE' value={mp.PackingHourlyRate}/>
                        <LabelAndInput label='PACK HOURS' value={mp.PackingHours}/>
                    </div>
                    : ''}
            </div>
            <div className='small mt-2'>
                <div className='row'>
                    <LabelAndInput label='TOTAL CHARGED TIME' value={mp.TotalChargeTime}/>
                    <LabelAndInput label='DISCOUNT TIME' value={mp.Discount}/>
                </div>
            </div>
        </>
    )
}

const LabelAndInput = ({label, value, inputClass}) => {
    return (
        <div className='col label-input-pair mb-2'>
            <label className='form-label fw-bold mb-1'>{label}</label>
            <input className={`form-control form-control-sm ${inputClass || ''}`} value={value || ''} disabled />
        </div>
    )
}